
const articleType = {
    loadAllArticle: "loadAllArticle",
    resetAllArticle: "resetAllArticle",
    updateArticle: "updateArticleData",
    resetUpdateArticle: "resetUpdateArticleData",
};

export default articleType;